/// Browser online state. Same optimistic idea as Flutter connectivity_plus:
/// treat "unknown" as online so we never hard-lock the app on a plugin glitch.

export function isOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine;
}

export function watchOnline(onChange: (online: boolean) => void): () => void {
  const on = (): void => onChange(true);
  const off = (): void => onChange(false);
  window.addEventListener('online', on);
  window.addEventListener('offline', off);
  return () => {
    window.removeEventListener('online', on);
    window.removeEventListener('offline', off);
  };
}
